/* MEGA MYSTERY BOX COMPANY — theme.js v2.0 */
const MMB = (() => {
  'use strict';
  let cartData = { items: [], item_count: 0, total_price: 0 };

  async function fetchCart() {
    try { cartData = await (await fetch('/cart.js')).json(); renderCart(); } catch(e){}
  }

  async function addToCart(variantId, qty=1, props={}) {
    try {
      const res = await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:variantId,quantity:qty,properties:props})});
      const data = await res.json();
      if(data.status){ showToast('Could not add to cart'); return; }
      await fetchCart(); openCart(); showToast(data.product_title + ' added to cart!');
    } catch(e){ showToast('Something went wrong'); }
  }

  async function changeQty(line, qty) {
    try { await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity:qty})}); await fetchCart(); } catch(e){}
  }

  function formatMoney(cents){ return '£'+(cents/100).toFixed(2); }

  function renderCart() {
    const count = cartData.item_count||0;
    const el = document.getElementById('cart-count');
    if(el) el.textContent = count;
    const list = document.getElementById('cart-items-list');
    const foot = document.getElementById('cart-footer');
    const tot  = document.getElementById('cart-total-display');
    if(!list) return;
    if(!cartData.items||cartData.items.length===0){
      list.innerHTML='<p class="cart-empty">Your cart is empty</p>';
      if(foot) foot.style.display='none'; return;
    }
    if(foot) foot.style.display='block';
    if(tot) tot.textContent = formatMoney(cartData.total_price);
    list.innerHTML = cartData.items.map((item,i)=>{
      const img = item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : '🎁';
      const props = item.properties ? Object.entries(item.properties).filter(([k,v])=>v&&!k.startsWith('_')).map(([k,v])=>`${k}: ${v}`).join(' · ') : '';
      return `<div class="cart-item"><div class="cart-item-img">${img}</div><div class="cart-item-info"><div class="cart-item-name">${item.product_title}</div>${props?`<div class="cart-item-props">${props}</div>`:''}<div class="cart-item-price">${formatMoney(item.final_line_price)}</div></div><div class="qty-ctrl"><button class="qty-btn" onclick="MMB.changeQty(${i+1},${item.quantity-1})">−</button><span class="qty-num">${item.quantity}</span><button class="qty-btn" onclick="MMB.changeQty(${i+1},${item.quantity+1})">+</button></div><button class="cart-remove" onclick="MMB.changeQty(${i+1},0)">🗑</button></div>`;
    }).join('');
  }

  function openCart(){ document.getElementById('cart-overlay')?.classList.add('is-open'); document.getElementById('cart-drawer')?.classList.add('is-open'); document.body.style.overflow='hidden'; fetchCart(); }
  function closeCart(){ document.getElementById('cart-overlay')?.classList.remove('is-open'); document.getElementById('cart-drawer')?.classList.remove('is-open'); document.body.style.overflow=''; }

  let toastTimer;
  function showToast(msg){ const t=document.getElementById('toast'); const m=document.getElementById('toast-msg'); if(!t||!m) return; m.textContent=msg; t.classList.add('is-visible'); clearTimeout(toastTimer); toastTimer=setTimeout(()=>t.classList.remove('is-visible'),3500); }

  function initMobileNav() {
    const toggle = document.getElementById('menu-toggle');
    const nav = document.getElementById('mobile-nav');
    if(!toggle||!nav) return;
    toggle.addEventListener('click',()=>{ nav.style.display = nav.style.display==='block'?'none':'block'; });
  }

  const builder = {
    step:1, fandoms:[], boxSize:'Standard', price:34.99, budget:50, msgIncluded:true,
    goToStep(n){
      for(let i=1;i<=4;i++){
        const p=document.getElementById('bp-'+i); const t=document.getElementById('bt-'+i);
        if(p) p.classList.toggle('is-active',i===n);
        if(t){ t.classList.remove('is-active','is-done'); if(i===n)t.classList.add('is-active'); else if(i<n)t.classList.add('is-done'); }
      }
      this.step=n; if(n===4) this.updateSummary();
    },
    toggleFandom(el,name){
      const idx=this.fandoms.indexOf(name);
      if(idx>-1){this.fandoms.splice(idx,1);el.classList.remove('is-selected');}
      else if(this.fandoms.length<3){this.fandoms.push(name);el.classList.add('is-selected');}
      else showToast('Max 3 fandoms — deselect one first');
    },
    selectSize(el,size,price){
      document.querySelectorAll('#bp-2 .option-btn').forEach(b=>b.classList.remove('is-selected'));
      el.classList.add('is-selected'); this.boxSize=size; this.price=parseFloat(price);
    },
    setBudget(v){ this.budget=parseInt(v); const el=document.getElementById('builder-budget-val'); if(el) el.textContent='£'+v; },
    setMsg(yes){ this.msgIncluded=yes; document.getElementById('builder-msg-yes')?.classList.toggle('is-selected',yes); document.getElementById('builder-msg-no')?.classList.toggle('is-selected',!yes); const inp=document.getElementById('builder-msg-input'); if(inp) inp.style.display=yes?'block':'none'; },
    updateSummary(){
      const b=document.getElementById('sum-box'); const f=document.getElementById('sum-fandoms'); const bu=document.getElementById('sum-budget'); const t=document.getElementById('sum-total');
      if(b) b.textContent=this.boxSize+' Box'; if(f) f.textContent=this.fandoms.length?this.fandoms.join(', '):'Not selected'; if(bu) bu.textContent='£'+this.budget; if(t) t.textContent='£'+this.price.toFixed(2);
    },
    addToCart(){
      const variantId = document.getElementById('builder-variant-id')?.value;
      if(!variantId){ showToast('Setup required: select Custom Box product in Theme Editor'); return; }
      const name = document.getElementById('recipient-name')?.value||'';
      const msg = document.getElementById('gift-message')?.value||'';
      const props = {'Box Size':this.boxSize,'Fandoms':this.fandoms.join(', ')||'Mixed','Budget':'£'+this.budget};
      if(name) props['Recipient']=name; if(this.msgIncluded&&msg) props['Gift Message']=msg;
      addToCart(variantId,1,props);
    }
  };

  function initParticles() {
    const c = document.getElementById('hero-particles'); if(!c) return;
    const colors = ['var(--gold)','var(--blue)','var(--purple-light)','#FFD740'];
    for(let i=0;i<10;i++){
      const el=document.createElement('div'); el.className='particle';
      el.style.cssText=`left:${20+Math.random()*60}%;top:${20+Math.random()*60}%;animation-delay:${(Math.random()*3).toFixed(1)}s;animation-duration:${(2+Math.random()*2).toFixed(1)}s;--tx:${Math.round((Math.random()-.5)*80)}px;--ty:${Math.round((Math.random()-.5)*80)}px;background:${colors[Math.floor(Math.random()*colors.length)]}`;
      c.appendChild(el);
    }
  }

  function initProductForms() {
    document.querySelectorAll('[data-add-to-cart]').forEach(btn=>{
      btn.addEventListener('click', async(e)=>{
        e.preventDefault(); const vid=btn.dataset.variantId||btn.closest('form')?.querySelector('[name="id"]')?.value;
        if(!vid) return; btn.textContent='Adding…'; btn.disabled=true;
        await addToCart(vid,1); btn.textContent=btn.dataset.label||'Add to Cart'; btn.disabled=false;
      });
    });
    document.querySelectorAll('form[action="/cart/add"]').forEach(form=>{
      form.addEventListener('submit', async(e)=>{
        e.preventDefault(); const vid=form.querySelector('[name="id"]')?.value;
        if(!vid) return;
        // Collect ALL line-item properties from this form (name="properties[...]")
        // so custom-box selections (fandoms, size, preferences, etc.) reach the cart.
        const props = {};
        form.querySelectorAll('[name^="properties["]').forEach(field=>{
          // For radio/checkbox groups, only take the checked one
          if((field.type==='radio'||field.type==='checkbox') && !field.checked) return;
          const m = field.name.match(/^properties\[(.+)\]$/);
          if(!m) return;
          const key = m[1];
          const val = (field.value||'').trim();
          if(val) props[key] = val;
        });
        const qty = parseInt(form.querySelector('[name="quantity"]')?.value,10) || 1;
        const btn=form.querySelector('[type="submit"]'); const orig=btn?.textContent;
        if(btn){btn.textContent='Adding…';btn.disabled=true;} await addToCart(vid,qty,props);
        if(btn){btn.textContent=orig||'Add to Cart';btn.disabled=false;}
      });
    });
  }

  function init() { fetchCart(); initMobileNav(); initParticles(); initProductForms(); document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart();}); }
  document.addEventListener('DOMContentLoaded', init);

  return { openCart, closeCart, showToast, addToCart, changeQty, builder };
})();
